import SolutionsHero from 'components/Solutions/Hero';
import React, { CSSProperties } from 'react';
import { IEHSImage } from 'utils/types';

export interface ISolutionsHeroContainer {
  title?: string;
  content: {
    headline: string;
    description?: {
      description: string;
    };
    cta?: {
      text: string;
      url: string;
    };
    desktopImage?: IEHSImage;
    backgroundColor?: string;
  };
  titleStyle?: CSSProperties;
  headlineStyle?: CSSProperties;
}

export const HeroContainer: React.FC<ISolutionsHeroContainer> = (props) => {
  const { content, title, titleStyle, headlineStyle } = props;

  if (!content) return null;

  const { headline, description, cta, desktopImage, backgroundColor } = content;

  const ctaContent = cta && {
    text: cta.text,
    url: cta.url,
  };

  return (
    <>
      <SolutionsHero
        title={title}
        headline={headline}
        description={description?.description}
        cta={ctaContent}
        desktopImage={desktopImage}
        backgroundColor={backgroundColor}
        titleStyle={titleStyle}
        headlineStyle={headlineStyle}
      />
    </>
  );
};

export default HeroContainer;
